import { render, staticRenderFns } from "./PlanHeader.vue?vue&type=template&id=3c1dbe68&scoped=true&"
import script from "./PlanHeader.vue?vue&type=script&lang=ts&"
export * from "./PlanHeader.vue?vue&type=script&lang=ts&"
import style0 from "./PlanHeader.vue?vue&type=style&index=0&id=3c1dbe68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1dbe68",
  null
  
)

export default component.exports